"use client";

import Image from "next/image";
import React, { ReactNode } from "react";
const StatsCard4 = ({
  title,
  subtitle,
  icon,
  gridStyle,
  logos
}: {
  title: string;
  subtitle: string;
  icon: ReactNode;
  gridStyle: {
    gridRow: string;
    gridColumn: string;
  };
  logos: {
    image: Image;
  }[];
}) => {
  const mid = Math.floor(logos.length / 2);
  return <div className="stats-section-card--4" style={gridStyle} data-sentry-component="StatsCard4" data-sentry-source-file="StatsCard4.tsx">
      <div>
      <div className="stats-section-card--title">
        {title}
      </div>
      <div className="stats-section-card--subtitle">
        {subtitle}
      </div>
      </div>
      <div className="image-cont">
        <Image className="c-image" src={"/images/course-diff/certif.svg"} alt="certif" width={419} height={172} data-sentry-element="Image" data-sentry-source-file="StatsCard4.tsx" />
      </div>
    </div>;
};
export default StatsCard4;